/** API route map: URLS.Controller.State */
export const State = {
      Name: 'State/',
      GetAll: 'get-all',
};
